export const isOldIpad = (): boolean => {
    if (typeof navigator === "undefined") return false;

    const userAgent = navigator.userAgent || navigator.vendor;
    const isIpad = /iPad/.test(userAgent) ||
        (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);

    if (!isIpad) return false;

    // Versuche, die iOS-Version aus "OS X_Y" zu extrahieren
    let match = userAgent.match(/OS (\d+)_/);
    let iosVersion = match ? parseInt(match[1], 10) : null;

    // Falls keine iOS-Version gefunden wurde, als Fallback Safari-Version analysieren
    if (iosVersion === null) {
        match = userAgent.match(/Version\/(\d+)\./);
        iosVersion = match ? parseInt(match[1], 10) : null;
    }

    return iosVersion !== null ? iosVersion <= 13 : false; // Falls keine Version erkannt wird, als neu betrachten
};
